<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="科目名称"
                        prop="name">
            <el-input v-model="search.name" placeholder="请输入科目名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否禁用"
                        key="is_disabled"
                        prop="is_disabled">
            <el-select v-model="search.is_disabled"
                       clearable
                       class="width-max">
              <el-option v-for="(label, key) in {1: '已禁用', 0: '启用中'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15 header">
        <div>
          <el-button type="primary"
                     @click="onCreate"
                      size="small">添加一级科目
          </el-button>
          <el-button type="primary"
                      icon="sj-icon-export"
                      @click="onExportAll"
                      size="small">导出
          </el-button>
        </div>
        <div>
          <el-button type="primary"
                     @click="$router.push('/finance-config/second-subject-management')"
                      size="small">二级科目列表
          </el-button>
          <el-button type="success"
                      @click="$router.push('/finance-config/subject-relationships-management')"
                      size="small">管理科目关系
          </el-button>
        </div>
      </div>
      <el-table ref="table"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column label="ID" width="70">
          <template slot-scope="scope">
            <span size="mini">{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <template v-for="(attr, index) of fields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="80">
          <template slot-scope="scope">
            <button-gutter>
              <el-button
                size="mini"
                :type="scope.row.is_disabled ? 'success' : 'danger'"
               @click="toggleEnable(scope.row)">{{scope.row.is_disabled ? '启用' : '禁用'}}</el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../finance-config.rules.js'
import financelConfigMixins from '../finance-config.mixins'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker, financelConfigMixins],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
        is_disabled: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: 'ID',
        },
        {
          key: 'name',
          text: '一级科目名称',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('subjectFirstLists', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onCreate () {
      this.$prompt('', '添加科目', {
        inputPattern: /\S+/,
        inputErrorMessage: '请输入科目名称',
        inputPlaceholder: '请输入科目名称',
      }).then(({value}) => {
        request.common('createSubjectFirst', {name: value}).then((res) => {
          this.$message.success('添加成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    toggleEnable (row) {
      this.$confirm(row.is_disabled ? '是否确定启用' : '该一级科目对应的科目关系将删除', '提示', {type: 'warning'}).then(() => {
        request.common(row.is_disabled ? 'enableSubjectFirst' : 'disableSubjectFirst', {id: row.id}).then((res) => {
          this.$message.success('更新成功')
          this.onRefresh()
        })
      })
    },
    onExportAll () {
      this.$export('一级科目', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/PaymentSubjectManagement.vue